import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Button, Divider, Header, Message, Icon, Segment } from 'semantic-ui-react';
import { useAuth, homePathFor } from '../context/AuthContext';
import logo from '../resources/logo.png';

function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error,    setError]    = useState('');
  const [loading,  setLoading]  = useState(false);
  const [showPass, setShowPass] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!username.trim() || !password) { setError('Please enter your username and password.'); return; }
    setLoading(true);
    const result = await login(username.trim(), password);
    setLoading(false);
    if (!result.ok) { setError(result.error); return; }
    navigate(homePathFor(result.role, '/rooms'), { replace: true });
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <Segment style={{ width: '100%', maxWidth: 460, padding: 36 }}>
        {/* Logo */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 20 }}>
          <img src={logo} alt="BHU" style={{ height: 52, width: 'auto', flexShrink: 0 }} />
          <div>
            <Header as="h1" style={{ margin: 0, fontSize: '1.1rem' }} content="Atithi" />
            <p style={{ margin: 0, opacity: 0.6 }}>Banaras Hindu University</p>
          </div>
        </div>

        <Divider />

        <Header as="h2" content="Sign In to Your Account" subheader="Enter your credentials to access the portal" />

        {error && (
          <Message negative>
            <Icon name="exclamation circle" />
            {error}
          </Message>
        )}

        <Form onSubmit={handleSubmit}>
          <Form.Input
            label="Username"
            placeholder="Enter your username"
            value={username}
            onChange={e => setUsername(e.target.value)}
            autoComplete="username"
            autoCapitalize="none"
          />

          <Form.Input
            label="Password"
            type={showPass ? 'text' : 'password'}
            placeholder="Enter your password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            autoComplete="current-password"
            icon={
              <Icon
                name={showPass ? 'eye slash' : 'eye'}
                link
                onClick={() => setShowPass(p => !p)}
              />
            }
          />

          <Button
            type="submit"
            color="blue"
            loading={loading}
            disabled={loading}
            fluid
          >
            {!loading && <Icon name="sign in" />}
            Sign In
          </Button>
        </Form>

        {/* Demo credentials — hidden from UI, kept for reference
        <div className="auth-demo-box">
          <p className="auth-demo-title"><Icon name="info circle" />Demo Credentials</p>
          <div className="auth-demo-grid">
            <div className="auth-demo-item">
              <span className="auth-demo-role admin-role">Admin</span>
              <code>admin@bhu.ac.in</code>
              <code>admin123</code>
            </div>
            <div className="auth-demo-item">
              <span className="auth-demo-role user-role">User</span>
              <code>priya.sharma@bhu.ac.in</code>
              <code>user123</code>
            </div>
          </div>
        </div>
        */}
      </Segment>
    </div>
  );
}

export default LoginPage;
